import { NavLink, Outlet } from "react-router-dom"

export default function LearnLayout() {
  return (
    <div className="container help-layout" dir="rtl">

      <h2 className="layout-title">تعليمات الموقع</h2>
     <h4 className="layout-list">
     يتكون الاختبار النظري من مجموعة تتكون من حوالي 1800 سؤال ، ومن المستحيل حفظ جميع الإجابات وتذكرها.

     </h4>
    <p className="layout-p">
     هنا سوف نقدم طريقة الدراسة على موقع <span className="text-primary-color"> 1sTest </span>  ونوضح بمساعدة شهادات الطلاب على الموقع كيف تعمل هذه الطريقة.

     </p>

      <nav className="layout-nav">
        <NavLink to="trafficLaws">قوانين المرور</NavLink>
        <NavLink to="roadSafety">السلامة على الطرق</NavLink>
        <NavLink to="vehicleKnowledge">معرفة المركبة</NavLink>
        <NavLink to="trafficSigns">اشارات  المرور</NavLink>
      </nav>

      <Outlet />
      

    </div>
  )
}
